// Lien vers la messagerie qui ouvre (ou crée) directement la conversation
// avec un agent / une agence — même principe que teqa_confirmation
// (paramètres receiver_type / receiver_id / subject / collaboration_id).
export const MESSAGING_PATH = "/admin-marketplace/messaging";

export function chatLink({ type, id, subject, collaborationId, offerId }) {
  const params = new URLSearchParams();
  if (type) params.set("receiver_type", type);
  if (id) params.set("receiver_id", String(id));
  if (subject) params.set("subject", subject);
  if (collaborationId) params.set("collaboration_id", String(collaborationId));
  if (offerId) params.set("offer_id", String(offerId));
  return `${MESSAGING_PATH}?${params.toString()}`;
}
